import type { Multiplicity } from "../SettingsPayload";

/** 何も設定していない状態。この形へ戻ったら設定そのものを持たない。 */
const DEFAULT_MAX = 1;

/**
 * 「何枚出すか」の変更から、保存すべき {@link Multiplicity} を求める。
 *
 * 数え方と上限は独立して決められる。数え方が空でも上限だけで意味を持つ（上限まで出しうるが、
 * 何を数えて何枚にするかは AI に委ねる）ため、上限だけの設定を許す。画面でも 2 つは別の行に
 * 並んでおり、片方を触るともう片方が捨てられるのは見た目の約束と合わない。
 *
 * どちらも既定（数え方が空・上限 1）へ戻ったときだけ `undefined` を返し、設定を持たない状態
 * へ畳む。空の設定を残すとファイルが膨らみ、「常に 1 枚」との区別も付かなくなるため。
 */
export function nextMultiplicity(
    current: Multiplicity | undefined,
    next: { counting?: string; max?: number }
): Multiplicity | undefined {
    const counting = next.counting ?? current?.counting ?? "";
    const max = next.max ?? current?.max ?? DEFAULT_MAX;
    // trim は「書かれていないか」の判定にだけ使う。保存する値を trim すると、欄が保存値を映す
    // 制御入力なので、打った空白がその場で消えて語を区切って書き進められない。
    const blank = counting.trim().length === 0;

    if (blank && max === DEFAULT_MAX) return undefined;
    return blank ? { max } : { counting, max };
}
